import { render } from "./Loader.vue?vue&type=template&id=05c61b7e&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=05c61b7e&scoped=true&lang=css"

import exportComponent from "/apps/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c61b7e"]])

export default __exports__